<template>
    <el-container style="height: 100vh; width: 100vw;">
        <!-- 侧边栏 -->
        <el-aside :width="asideWidth" style="background-color: #33363c;">
            <sidebar ref="sidebar"></sidebar>
        </el-aside>

        <el-container>
            <!-- 导航栏一 -->
            <el-header height="60px" style="background-color: #F3F3F3">
                <navibar-top ref="navigateBarTop" @sidebarToggle="sidebarToggleClick"></navibar-top>
            </el-header>

            <!-- 导航栏二 -->
            <el-header height="40px" style="border-bottom:thin solid #eee; padding:0;">
                <navibar-bottom ref="navigateBarBottom"></navibar-bottom>
            </el-header>

            <!-- main -->
            <el-main>
                <keep-alive :include="cachedViews" v-if="isRouterAlive">
                    <router-view></router-view>
                </keep-alive>
            </el-main>
        </el-container>
    </el-container>
</template>

<script>
    import Sidebar from "@comps/layout/Sidebar";
    import NavibarTop from "@comps/layout/NavibarTop";
    import NavibarBottom from "@comps/layout/NavibarBottom";

    export default {
        name: "layout",
        components: {
            "navibar-top": NavibarTop,
            "navibar-bottom": NavibarBottom,
            "sidebar": Sidebar
        },
	    provide(){
		    return{
			    routerViewReload: this.routerViewReload
		    }
	    },
        data() {
            return {
                asideWidth: '11vw',
                isRouterAlive: true
            };
        },
        methods: {
            /**
             * 侧边栏展开、缩起状态切换
             */
        	sidebarToggleClick() {
                this.$refs.sidebar.stateToggle();
                this.$refs.sidebar.isCollapse ? this.asideWidth = '3.4vw' : this.asideWidth = '11vw'
            },

	        /**
             * 刷新路由，防止点击同一路径不刷新
	         */
	        routerViewReload(){
		        this.isRouterAlive = false;
		        this.$nextTick(function () {
			        this.isRouterAlive = true;
		        })
	        }
        }
    };
</script>



// WEBPACK FOOTER //
// src/view/layout/index.vue